import React from 'react';
import { FadeIn } from './FadeIn';
import { BookMockup } from './BookMockup';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShoppingCart } = FiIcons;

const AFFILIATE_URL = 'https://amzn.to/46L71gr';

function handleAmazonClick() {
  if (typeof window.trackAmazonClick === 'function') {
    window.trackAmazonClick('hero_section', 'Jetzt auf Amazon ansehen');
  }
}

export const Hero = () => {
  return (
    <section className="relative min-h-screen bg-navy flex items-center pt-16 pb-24 md:pb-16 overflow-hidden">
      <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-gold/5 blur-[120px] pointer-events-none"></div>
      <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-blue-500/10 blur-[120px] pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 w-full relative z-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10 lg:gap-16">

          <div className="w-full lg:w-1/2 order-1 lg:order-2 flex justify-center lg:justify-end">
            <FadeIn direction="left" delay={0.1}>
              <BookMockup />
            </FadeIn>
          </div>

          <div className="w-full lg:w-1/2 order-2 lg:order-1 text-center lg:text-left">
            <FadeIn direction="right">
              <span className="inline-block py-1 px-3 rounded-full bg-gold/10 text-gold font-sans text-xs font-semibold tracking-wider mb-5 border border-gold/20">
                Der Praxis-Guide für echten Cashflow
              </span>
              <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white font-bold leading-tight mb-5">
                Bauen Sie Ihre eigene <br />
                <span className="text-gold italic">Geld-Fabrik</span>
              </h1>
              <p className="font-sans text-base md:text-lg text-gray-300 mb-8 leading-relaxed max-w-xl mx-auto lg:mx-0">
                Wie Sie mit REITs, BDCs und ETFs ein monatliches Einkommen an der Börse generieren – ganz ohne Kursstress.
              </p>
              <a
                href={AFFILIATE_URL}
                target="_blank"
                rel="noopener noreferrer sponsored"
                onClick={handleAmazonClick}
                data-action="amazon-click"
                data-source="hero_section"
                className="inline-flex items-center justify-center gap-3 px-8 py-4 text-navy bg-gold font-sans font-bold text-base rounded transition-all duration-300 shadow-[0_0_20px_rgba(212,175,55,0.3)] hover:shadow-[0_0_35px_rgba(212,175,55,0.6)] hover:scale-105 hover:brightness-110 w-full sm:w-auto"
              >
                <SafeIcon icon={FiShoppingCart} className="text-lg" />
                Jetzt auf Amazon ansehen
              </a>
            </FadeIn>
          </div>

        </div>
      </div>
    </section>
  );
};